module.exports = __webpack_public_path__ + "static/media/edit.3326e414.svg";